import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import { Spinner } from '@bibliocommons/base-icons';
import './EmptyContentPanel.scss';

export default function EmptyContentPanel({ icon, title, subtitle, fetching, children }) {
  const renderContents = () => (
    <div className="contents">
      {title && <h2 className="title-wrapper">{title}</h2>}
      {subtitle && <h3 className="subtitle-wrapper">{subtitle}</h3>}
      {children}
    </div>
  );

  const renderLoading = () => (
    <div className="loading">
      <Spinner primary />
      <FormattedMessage id="loading" />
    </div>
  );

  return (
    <div className="cp-empty-content-panel">
      { icon && <div className="icon-wrapper">{icon}</div> }
      { fetching ? renderLoading() : renderContents() }
    </div>
  );
}

EmptyContentPanel.propTypes = {
  icon: PropTypes.element,
  title: PropTypes.node,
  subtitle: PropTypes.node,
  fetching: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};



// WEBPACK FOOTER //
// ./app/components/shared/EmptyContentPanel/EmptyContentPanel.jsx